/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  /**
   * @function getPersonalizationData
   * @return Object - Returns the component name with the component personalization data.
   */
  getPersonalizationData(state, getters, rootState) {
    const componentName = getters.getPersonalizationComponentName;
    const recipeComponent = componentName ?
      rootState.recipe.recipe_v2.components[componentName] : null;

    return { componentName, personalization: recipeComponent?.personalization ?? null };
  },
  /**
   * @function getParentComponentName
   * @return String - Returns the primary personalization component (i.e: personalization)
   */
  getPrimaryComponentName(store, getters, rootState) {
    if (!rootState.utils.pdm) return [];
    const { pdm } = rootState.utils;
    const componentKeys = Object.keys(pdm.components);
    const componentName = componentKeys.filter(
      component =>
        pdm.components[component].hasOwnProperty("personalization_data") &&
        pdm.components[component].personalization_data instanceof Array
    );

    return componentName.length ? componentName[0]: "";
  },
  /**
   * @function getPersonalizationComponent
   * @return String - Returns the sibling component to the personalization component (i.e: heel_counter or quarters)
   */
  getPersonalizationComponentName(store, getters, rootState) {
    if (!rootState.utils.pdm) return [];
    const { pdm } = rootState.utils;
    const parentComponent = getters.getPrimaryComponentName;
    return pdm.components[parentComponent]?.personalization_sibling_component ?? null;
  },
  getItemsData(state, getters, rootState) {
    if (!rootState.utils.pdm || !rootState.utils.pdm.components.personalization) return [];
    const { pdm } = rootState.utils;
    const personalization = [...pdm.components.personalization.personalization_data];
    return personalization;
  },
  getCurrentStep(state) {
    return state.currentStep;
  },
  isPersonalizationInComponentRecipe(state, getters, rootState) {
    const component = getters.getPersonalizationComponentName;

    return () => {
      if (!component) {
        return false;
      }

      const recipeComponent = rootState.recipe.recipe_v2.components[component];

      return recipeComponent && recipeComponent.personalization instanceof Array;
    }
  },
  isPersonalizationComponentInPdm(state, getters, rootState) {
    const { pdm } = rootState.utils;
    return pdm && !!pdm.components['personalization'];
  }
};
export default getters;
